import { debounce } from 'lodash';

import initialFilters from '../constants/initialFilters';

const getFiltersAppConfig = ({
  setFilters,
  staticFilters,
  ignoredParamsKeys,
}) => ({
  handleFiltersUpdate: debounce((filters) => {
    setFilters(filters);
  }, 200),
  initialFilters,
  staticFilters,
  ignoredParamsKeys,
});

export default getFiltersAppConfig;
